const serviceService = require('../../services/service/serviceService')

const state = {
  serviceTypes: []
}

const mutations = {
  setServiceTypes(state, serviceTypes) {
    state.serviceTypes = serviceTypes
  }
}

const actions = {
  async fetchServiceTypes({ commit }) {
    try {
      const { data } = await serviceService.list()
      commit('setServiceTypes', data)
    } catch { }
  },
}

const getters = {
  serviceTypes: (state) => state.serviceTypes
}

export default {
  state,
  mutations,
  actions,
  getters,
}
